import React from 'react';
import type { ProductionLineStage } from '../../utils/types';

interface Tab {
  key: ProductionLineStage;
  label: string;
  icon: React.ComponentType<any>;
  color: string;
}

interface ProductionLineTabNavigationProps {
  tabs: Tab[];
  activeTab: ProductionLineStage;
  onTabChange: (tab: ProductionLineStage) => void;
}

export const ProductionLineTabNavigation: React.FC<ProductionLineTabNavigationProps> = ({
  tabs,
  activeTab,
  onTabChange
}) => {
  return (
    <div className="mb-6">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Production Line Tabs">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.key;
            const Icon = tab.icon;
            
            return (
              <button
                key={tab.key}
                onClick={() => onTabChange(tab.key)}
                className={`
                  whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm 
                  flex items-center space-x-2 transition-colors
                  ${isActive
                    ? `border-${tab.color}-500 text-${tab.color}-600`
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                `}
              >
                <Icon className="w-4 h-4" />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};
